import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function StaffLogin() {
  const { staffLogin } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await staffLogin(username.trim(), pin.trim());
      navigate("/staff");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-forest flex items-center justify-center p-5" data-testid="staff-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 text-gold"><Sparkles size={18} /><span className="font-serif text-2xl text-cream">The Rose Airbnb</span></div>
          <p className="text-cream/60 text-sm mt-2">Service Staff Portal</p>
        </div>
        <form onSubmit={submit} className="bg-cream rounded-2xl p-6 space-y-4 shadow-xl" data-testid="staff-login-form">
          <div>
            <label className="text-xs text-stone-500">Username</label>
            <input value={username} onChange={(e) => setUsername(e.target.value)} autoCapitalize="none" autoCorrect="off"
              data-testid="staff-username" className="w-full mt-1 rounded-lg border border-stone-200 px-3 py-3 text-base focus:outline-none focus:ring-2 focus:ring-rose/30" placeholder="your username" required />
          </div>
          <div>
            <label className="text-xs text-stone-500">PIN</label>
            <input value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))} inputMode="numeric" maxLength={6} type="password"
              data-testid="staff-pin" className="w-full mt-1 rounded-lg border border-stone-200 px-3 py-3 text-base tracking-[0.5em] focus:outline-none focus:ring-2 focus:ring-rose/30" placeholder="••••" required />
          </div>
          <button type="submit" disabled={busy} data-testid="staff-login-submit" className="btn-primary w-full justify-center py-3 disabled:opacity-60">
            {busy ? <Loader2 className="animate-spin" size={18} /> : "Sign in"}
          </button>
          <p className="text-center text-xs text-stone-400">Forgot your PIN? Ask your administrator to reset it.</p>
        </form>
      </div>
    </div>
  );
}
